// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.location {
    display: flex;
    align-items: flex-start;
    justify-content: center; /* 가운데 정렬 */
    max-width: 1200px;       /* 전체 영역 최대 너비 */
    margin: 40px auto;       /* 가운데 정렬 + 위아래 여백 */
    gap: 20px;               /* map과 info 사이 간격 */
}

.map {
    width: 600px;            /* 지도 영역 고정 */
    flex-shrink: 0;          /* 축소되지 않도록 */
}

.info {
    flex: 1;
    padding-left: 20px;
}

.info h2 {
    margin-top: 0;
    font-size: 18px;
}

iframe {
    width: 100%;
    height: 450px;
    border: 0;
}

/* 반응형: 화면이 768px 이하일 때 */
@media (max-width: 768px) {
    .location {
        flex-direction: column;   /* 세로 정렬 */
        align-items: center;      /* 가운데 정렬 */
        gap: 30px;
    }

    .map {
        width: 100%;              /* 모바일에서는 가로 100% */
        max-width: 600px;         /* 너무 커지지 않게 제한 */
    }

    .info {
        padding-left: 0;
        text-align: center;       /* 가운데 정렬 */
    }

    iframe {
        height: 350px;            /* 모바일에서 조금 낮게 */
    }
}`, "",{"version":3,"sources":["webpack://./static/css/location.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB,EAAE,WAAW;IACpC,iBAAiB,QAAQ,gBAAgB;IACzC,iBAAiB,QAAQ,oBAAoB;IAC7C,SAAS,gBAAgB,oBAAoB;AACjD;;AAEA;IACI,YAAY,aAAa,aAAa;IACtC,cAAc,WAAW,aAAa;AAC1C;;AAEA;IACI,OAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,SAAS;AACb;;AAEA,yBAAyB;AACzB;IACI;QACI,sBAAsB,IAAI,UAAU;QACpC,mBAAmB,OAAO,WAAW;QACrC,SAAS;IACb;;IAEA;QACI,WAAW,eAAe,mBAAmB;QAC7C,gBAAgB,UAAU,iBAAiB;IAC/C;;IAEA;QACI,eAAe;QACf,kBAAkB,QAAQ,WAAW;IACzC;;IAEA;QACI,aAAa,aAAa,gBAAgB;IAC9C;AACJ","sourcesContent":[".location {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center; /* 가운데 정렬 */\n    max-width: 1200px;       /* 전체 영역 최대 너비 */\n    margin: 40px auto;       /* 가운데 정렬 + 위아래 여백 */\n    gap: 20px;               /* map과 info 사이 간격 */\n}\n\n.map {\n    width: 600px;            /* 지도 영역 고정 */\n    flex-shrink: 0;          /* 축소되지 않도록 */\n}\n\n.info {\n    flex: 1;\n    padding-left: 20px;\n}\n\n.info h2 {\n    margin-top: 0;\n    font-size: 18px;\n}\n\niframe {\n    width: 100%;\n    height: 450px;\n    border: 0;\n}\n\n/* 반응형: 화면이 768px 이하일 때 */\n@media (max-width: 768px) {\n    .location {\n        flex-direction: column;   /* 세로 정렬 */\n        align-items: center;      /* 가운데 정렬 */\n        gap: 30px;\n    }\n\n    .map {\n        width: 100%;              /* 모바일에서는 가로 100% */\n        max-width: 600px;         /* 너무 커지지 않게 제한 */\n    }\n\n    .info {\n        padding-left: 0;\n        text-align: center;       /* 가운데 정렬 */\n    }\n\n    iframe {\n        height: 350px;            /* 모바일에서 조금 낮게 */\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
